import { useAppTakeoverMenuSection } from 'features/app-takeover/hooks/use-app-takeover';
import { StyleSheet } from 'react-native';

import { Typography } from 'components/ui';

interface TakeoverMenuSectionSubtitleProps {
  sectionId: string;
}

export const TakeoverMenuSectionSubtitle = ({ sectionId }: TakeoverMenuSectionSubtitleProps) => {
  const { fontColor, sectionTileSubtitle } = useAppTakeoverMenuSection(sectionId);

  if (!sectionTileSubtitle) {
    return null;
  }

  const isPlainString = typeof sectionTileSubtitle === 'string';
  const text = isPlainString ? sectionTileSubtitle : sectionTileSubtitle.text;
  const color = isPlainString ? fontColor : sectionTileSubtitle.color ?? fontColor;
  const configuredTypography =
    !isPlainString &&
    (sectionTileSubtitle.fontSize !== undefined || sectionTileSubtitle.lineHeight !== undefined)
      ? {
          fontSize: sectionTileSubtitle.fontSize,
          lineHeight: sectionTileSubtitle.lineHeight,
        }
      : undefined;

  return (
    <Typography
      color={color}
      numberOfLines={1}
      style={[styles.subtitle, configuredTypography]}
      testID={`menu-section-tile-subtitle-${sectionId}`}
    >
      {text}
    </Typography>
  );
};

const styles = StyleSheet.create({
  subtitle: {
    flexShrink: 1,
    fontSize: 14,
    lineHeight: 18,
  },
});
